import React, { useState } from 'react';
import { useImportBatches, useImportBatchMutations } from '../../utils/hooks/useImportBatches';
import { Toast } from '../atoms/Toast';

type ToastState = { message: string; type: 'success' | 'error' } | null;

export const ImportBatchesList: React.FC = () => {
  const { data: batches, isLoading } = useImportBatches();
  const { deleteImportBatch } = useImportBatchMutations();
  const [deletingId, setDeletingId] = useState<string | null>(null);
  const [toast, setToast] = useState<ToastState>(null);

  const handleDelete = async (id: string, label: string, itemCount: number) => {
    const confirmed = window.confirm(
      `Supprimer l'import "${label}" ? Les ${itemCount} transaction(s) importée(s) avec ce fichier seront également supprimées. Cette action est irréversible.`
    );
    if (!confirmed) return;

    setDeletingId(id);
    try {
      await deleteImportBatch(id);
      setToast({ message: 'Import et transactions associées supprimés.', type: 'success' });
    } catch (error) {
      console.error('Erreur lors de la suppression du lot d\'import:', error);
      setToast({ message: 'Erreur lors de la suppression de l\'import.', type: 'error' });
    } finally {
      setDeletingId(null);
    }
  };

  if (isLoading) {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400 px-4 py-3">Chargement...</p>
    );
  }

  if (!batches || batches.length === 0) {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400 px-4 py-3">Aucun import CSV pour le moment.</p>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
        <p className="text-xs text-gray-500 dark:text-gray-400">
          Supprimer un import retire aussi toutes les transactions qu'il a créées.
        </p>
      </div>
      <ul className="divide-y divide-gray-100 dark:divide-gray-800">
        {batches.map((batch) => (
          <li key={batch.id} className="flex items-center justify-between px-4 py-3">
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">{batch.label}</p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {new Date(batch.createdAt).toLocaleString('fr-FR')} · {batch.itemCount} transaction(s)
              </p>
            </div>
            <button
              onClick={() => handleDelete(batch.id, batch.label, batch.itemCount)}
              disabled={deletingId === batch.id}
              className="ml-4 shrink-0 px-3 py-1.5 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50"
            >
              {deletingId === batch.id ? 'Suppression...' : 'Supprimer'}
            </button>
          </li>
        ))}
      </ul>
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
};
